import React, { useState } from "react";
import UsersTable from './UsersTable'
import GroupAccessControl from './GroupAccessControl'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { IconButton } from '@mui/material';

export default function UserMaintenance() {
  const [activeTab, setActiveTab] = useState("VLP Users");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="container">

      <div className="tabs is-left">
        <ul>
          {["VLP Users", "Group Access Control", "Page Control"].map((tab) => (
            <li key={tab} className={activeTab === tab ? "is-active" : ""}>
              <a onClick={() => handleTabClick(tab)}>
                <IconButton aria-label="Tab" color="primary">
                  <PersonOutlineIcon />
                </IconButton>

                <span>{tab}</span>
              </a>
            </li>
          ))}
        </ul>
      </div>

      <div className="content">
        <div className="container">
          {/* Render content based on the activeTab */}
          {activeTab === "Group Access Control" && <GroupAccessControl />}
          {activeTab === "Page Control" && (
            /* Replace with your component for Page Control */
            <div>Page Control Content</div>
          )}
          {activeTab === "VLP Users" && (
            /* Replace with your component for VLP Users */
            <UsersTable />
          )}
        </div>
      </div>
    </div>
  );
}
